<template>
  <ExhibitionContainer
    :trade-show-name="'Home Delivery World 2026'"
    :activation-message="'Please scan your badge QR code'"
    has-badge-number-input
    :ble-id="label_id"
    :asset-id="asset_id"
    :token="t"
    :form-id="hubspotIds.formId"
    :portal-id="hubspotIds.portalId"
    :region="hubspotIds.region"
  >
    <template slot="banner">
      <Banner
        booth-number="Stand 602"
      />
    </template>
  </ExhibitionContainer>
</template>
<script>
import ExhibitionContainer from '../../components/organisms/exhibitions/exhibition-container';
import Banner from '../../components/molecules/exhibitions/home-delivery-world-2026-banner';

export default {
  name: 'HomeDeliveryWorld2026',
  components: {
    Banner,
    ExhibitionContainer,
  },
  props: {
    // eslint-disable-next-line vue/prop-name-casing
    label_id: { type: String, required: true },
    // eslint-disable-next-line vue/prop-name-casing
    asset_id: { type: String, required: true },
    t: { type: String, default: '' },
  },
  computed: {
    hubspotIds() {
      return {
        formId: '46c687bb-2bc4-4bb8-ac42-e7c08ac0c9d6',
        portalId: '27004227',
        region: 'eu1',
      };
    },
  },
};
</script>
